import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
import ButtonCommon from "../../buttons/ButtonCommon.vue";
import TooltippedText from "../../tooltip/TooltippedText/TooltippedText.vue";
import vuetify from '../../../service/useVuetify';


export default /*#__PURE__*/_defineComponent({
  __name: 'SideBar',
  props: {
    tabNames: null,
    title: { default: '' },
    subtitle: null,
    cancelButton: { default: "Cancel" },
    drawerOpen: { type: Boolean },
    actions: { type: Boolean, default: true },
    temporary: { type: Boolean, default: true },
    permanent: { type: Boolean, default: false },
    activeTab: null,
    mini: { type: Boolean, default: false },
    pushMainContent: { type: Boolean }
  },
  emits: ["closeSidebar", "changeActiveTab"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: "closeSidebar"): void;
  (e: 'changeActiveTab', value: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { tabNames?: Array<string>, title: string, subtitle?: string, cancelButton: string, drawerOpen?: boolean, actions: boolean, temporary: boolean, permanent: boolean, activeTab?:number, mini:boolean, pushMainContent?:boolean };





watch(
  () => props.activeTab,
  () => {
    selectedTab.value = props.activeTab
  }
);

const selectedTab = computed({
  get: () => props.activeTab,
  set: (newValue) => {
    if (newValue !== props.activeTab) {
      emit("changeActiveTab", newValue);
    }
  }
});

const height = computed(() => {
  switch (vuetify.value && vuetify.value.breakpoint.name) {
    case "sm":
      return "calc(100vh - 44px) !important";
    case "md":
    case "lg":
      return "calc(100vh - 56px) !important";
    case "xl":
      return "calc(100vh - 64px) !important";
    default:
      return "calc(100vh - 64px) !important";
  }
})

const tabSize = computed(() => {
  if (!vuetify.value || !props.tabNames || props.tabNames.length < 3) {
    return "420px"
  } else if (!props.mini) {
    switch (vuetify.value.breakpoint.name) {
      case 'sm': return "calc(100% - 48px) !important"
      case 'md': return "calc(100% - 56px) !important"
      case 'lg': return "calc(100% - 212px) !important"
      case 'xl': return "calc(100% - 252px) !important"
      default : return "420px"
    }
  } else {
    return "calc(100% - 56px) !important"
  }
})

const openDrawer = computed({
  get: () => {
    return props.drawerOpen;
  },
  set: (value) => {
    if (!value) {
      emit("closeSidebar");
    }
  }
})

expose({ tabSize });

return { __sfc: true,props, emit, selectedTab, height, tabSize, openDrawer, ButtonCommon, TooltippedText }
}

})